import { Loader } from "@googlemaps/js-api-loader";

const map = function () {

	console.log('MAPS')

	const loader = new Loader({
		apiKey: "AIzaSyD8HiXhBeDt4UcTh-HO2jplgxtydFHBKSw",
		version: "weekly",
	});

	let allMaps = document.querySelectorAll(".map");
	if (allMaps.length === 0) return;

	console.log('allMaps', allMaps)

	function initMap(mapID, lat, lng, zoom, marker) {
		const map = new google.maps.Map(document.getElementById(mapID), {
			mapId: "34efb51596055c3f",
			center: { lat: Number(lat), lng: Number(lng) },
			zoom: Number(zoom),
			disableDefaultUI: true,
			gestureHandling: "none",
			zoomControl: false,
		});
		new google.maps.Marker({
			position: { lat: Number(lat), lng: Number(lng) },
			map,
			icon: marker,
		});
	}

	loader
		.load()
		.then((google) => {
			allMaps.forEach((map) => {
				console.log("map found", map);
				let d = map.dataset;
				initMap(map.id, d.lat, d.lng, d.zoom);
			});
		})
		.catch((e) => {
			// do something
			console.log("error!", e);
		});
};

export default map;
